module.exports = __webpack_public_path__ + "static/media/green-wall.8d9bb46d.jpg";